import { render, staticRenderFns } from "./StudentCourses.vue?vue&type=template&id=deb29574&scoped=true&"
import script from "./StudentCourses.vue?vue&type=script&lang=js&"
export * from "./StudentCourses.vue?vue&type=script&lang=js&"
import style0 from "./StudentCourses.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StudentCourses.vue?vue&type=style&index=1&id=deb29574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb29574",
  null
  
)

export default component.exports